import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-phone',
  templateUrl: './email-phone.component.html',
  styleUrls: ['./email-phone.component.scss']
})
export class EmailPhoneComponent implements OnInit {

  @Input() data;

  @Input() onlyPhone;
  @Input() onlyEmail;
  @Input() location;

  constructor() { }

  ngOnInit(): void {
  }

  formatUSPhoneNumber(phoneNumber:string): string | null {
    // Remove all non-digit characters from the input
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    
    // Check if the remaining string has 10 digits (valid US phone number)
    if (digitsOnly.length === 10) {
        // Format the phone number as (xxx) xxx-xxxx
        return digitsOnly.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    } else {
        return null; // Return null for invalid phone numbers
    }
}


}
